import { createRouter, createWebHistory } from 'vue-router';
import routes from './constants/routes';
import store from './store';

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return { left: 0, top: 0 };
  },
});

router.beforeEach((to, from, next) => {
  const { isAuthorized, mfaIsRequired } = store.getters;
  const loadingApp = store.getters.showSiteLoader;

  const anonymousAccessPages = routes.filter((r) => r.allowAnonymous).map((r) => r.name);

  if (!loadingApp && !isAuthorized && anonymousAccessPages.indexOf(to.name) === -1) {
    store.dispatch('clearUser');
    router.replace('/login');
    return;
  }

  // Block user from going past main account page without setting up MFA
  if (mfaIsRequired && anonymousAccessPages.indexOf(to.name) === -1 && to.name !== 'account') {
    store.commit('setGlobalAlert', {
      msg: 'You must configure MFA before continuing to use KGB Aviation Solutions Portal.',
      error: true,
    });
    router.replace('/account');

    return;
  }

  if (!to.matched.length) {
    return next({ name: 'login' });
  }

  if (to.matched.length) {
    if (to.meta.title) {
      document.title = `KGB Aviation | ${to.meta.title}`;
    } else {
      document.title = 'KGB Aviation';
    }

    next();
  }
});

export default router;
